$(document).ready(function () {
  if ($('#fp-homepage').length) {
    var sectionSelector = ".fp-section";
    $('#fp-homepage').fullpage({
      keyboardScrolling: true,
      navigation: true,
      sectionSelector: sectionSelector,
      slideSelector: '.fp-slide',
      licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
      scrollOverflow: true,
      afterLoad: function () {
        $("body").removeClass("invisible");
      },
      onLeave: function (origin, destination, direction) {
        if(destination.index == 0) {
          setNavType("gray");
        }else if(destination.index == ($(sectionSelector).length - 1)) {
          window.dispatchEvent(new Event('resize'));
          setNavType("grayWithBar");
        }else {
          setNavType("white");
        }
      }
    });
  }
});